module.exports = __webpack_public_path__ + "img/2.89f2514b.png";